import { combineReducers } from "@reduxjs/toolkit";

import { USER_API_REDUCER_KEY, userApi } from "@store/services/user";
import { NOTIFICATIONS_API_REDUCER_KEY, notificationsApi } from "@store/services/notifications";
import { PARTNER_API_REDUCER_KEY, partnerApi } from "@store/services/partner";
import { BIFROST_BOOKINGS_API_REDUCER_KEY, bifrostBookingsApi } from "@store/services/bifrostBookings";
import { bifrostFilesApiReducerKey, bifrostFilesApi } from "@store/services/bifrostFiles";
import { bifrostFilesMagicLinkApiReducerKey, bifrostFilesMagicLinkApi } from "@store/services/bifrostFilesMagicLink";
import appReducer from "./slices/appSlice";
import modalReducer from "./slices/modalSlice";
import cartSlice from "./slices/cartSlice";
import futurePowSlice from "../routes/SimpleDocumentsCreation/FuturePow/FuturePowSlice";
import twoFuturePowBundleSlice from "../routes/SimpleDocumentsCreation/TwoFuturePowBundle/TwoFuturePowBundleSlice";
import { DOCUMENTS_API_REDUCER_KEY, documentsApi } from "@store/services/documents";
import { IDENTIFICATION_FILES_API_KEY, identificationFilesApi } from "@store/services/identificationFiles";
import {
  IDENTIFICATION_FILES_NON_USER_API_KEY,
  identificationFilesNonUserApi,
} from "@store/services/identificationFilesNonUser";
import {
  identificationFilesMagicLinkApiKey,
  identificationFilesMagicLinkApi,
} from "@store/services/identificationFilesMagicLink";
import {
  identificationFilesUploadApiKey,
  identificationFilesUploadApi,
} from "@store/services/identificationFilesUpload";
import { LAWDOCS_API_REDUCER_KEY, lawdocsApi } from "./services/lawdocs";
import { BOOKING_METADATA_REDUCER_KEY, bookingMetadataApi } from "./services/bookingMetadata";
import { BOOKING_METADATA_MAGIC_LINK, bookingMetadataMagicLinkApi } from "./services/bookingMetadataMagicLink";
import { BOOKING_METADATA_NON_USER, bookingMetadataNonUserApi } from "./services/bookingMetadataNonUser";
import { middleServiceMagicLink, middleServiceMagicLinkApi } from "./services/middleServiceMagicLink";
import { magicLinkResendReducerKey, magicLinkResendApi } from "./services/magicLinkResend";
import { authenticationApiReducerKey, authenticationApi } from "./services/authentication";
import {
  myDocumentsPreviewMagicLinkApiKey,
  myDocumentsPreviewMagicLinkApi,
} from "./services/myDocumentsPreviewMagicLink";
import { accountSetupMagicLinkApiKey, accountSetupMagicLinkApi } from "./services/accountSetupMagicLink";
import { DOCUMENT_INFO_API_REDUCER_KEY, documentInfoApi } from "./services/documentInfo";
import { BUNDLE_INFO_API_REDUCER_KEY, bundleInfoApi } from "./services/bundleInfo";
import { SHOPIFY_API_REDUCER_KEY, shopifyApi } from "./services/shopify";
import { USER_DOCUMENTS_API_REDUCER_KEY, userDocumentsApi } from "./services/userDocuments";
import { USER_INFO_API_REDUCER_KEY, userInfoApi } from "./services/userInfo";
import { TRACKING_INFO_API_REDUCER_KEY, trackingInfoApi } from "./services/trackingInfo";
import { ONBOARDING_API_REDUCER_KEY, onboardingApi } from "./services/onboarding";
import { REQUEST_CALL_API_REDUCER_KEY, requestCallApi } from "./services/requestCall";
import { CAMPAIGN_VOUCHER_API_REDUCER_KEY, campaignVoucherApi } from "./services/campaignVoucher";

const rootReducer = combineReducers({
  [USER_API_REDUCER_KEY]: userApi.reducer,
  [NOTIFICATIONS_API_REDUCER_KEY]: notificationsApi.reducer,
  [PARTNER_API_REDUCER_KEY]: partnerApi.reducer,
  [DOCUMENTS_API_REDUCER_KEY]: documentsApi.reducer,
  [IDENTIFICATION_FILES_API_KEY]: identificationFilesApi.reducer,
  [IDENTIFICATION_FILES_NON_USER_API_KEY]: identificationFilesNonUserApi.reducer,
  [identificationFilesUploadApiKey]: identificationFilesUploadApi.reducer,
  [identificationFilesMagicLinkApiKey]: identificationFilesMagicLinkApi.reducer,
  [BIFROST_BOOKINGS_API_REDUCER_KEY]: bifrostBookingsApi.reducer,
  [bifrostFilesApiReducerKey]: bifrostFilesApi.reducer,
  [bifrostFilesMagicLinkApiReducerKey]: bifrostFilesMagicLinkApi.reducer,
  [LAWDOCS_API_REDUCER_KEY]: lawdocsApi.reducer,
  [BOOKING_METADATA_REDUCER_KEY]: bookingMetadataApi.reducer,
  [BOOKING_METADATA_MAGIC_LINK]: bookingMetadataMagicLinkApi.reducer,
  [BOOKING_METADATA_NON_USER]: bookingMetadataNonUserApi.reducer,
  [middleServiceMagicLink]: middleServiceMagicLinkApi.reducer,
  [magicLinkResendReducerKey]: magicLinkResendApi.reducer,
  [authenticationApiReducerKey]: authenticationApi.reducer,
  [myDocumentsPreviewMagicLinkApiKey]: myDocumentsPreviewMagicLinkApi.reducer,
  [accountSetupMagicLinkApiKey]: accountSetupMagicLinkApi.reducer,
  [DOCUMENT_INFO_API_REDUCER_KEY]: documentInfoApi.reducer,
  [BUNDLE_INFO_API_REDUCER_KEY]: bundleInfoApi.reducer,
  [SHOPIFY_API_REDUCER_KEY]: shopifyApi.reducer,
  [USER_DOCUMENTS_API_REDUCER_KEY]: userDocumentsApi.reducer,
  [USER_INFO_API_REDUCER_KEY]: userInfoApi.reducer,
  [TRACKING_INFO_API_REDUCER_KEY]: trackingInfoApi.reducer,
  [ONBOARDING_API_REDUCER_KEY]: onboardingApi.reducer,
  [REQUEST_CALL_API_REDUCER_KEY]: requestCallApi.reducer,
  [CAMPAIGN_VOUCHER_API_REDUCER_KEY]: campaignVoucherApi.reducer,
  app: appReducer,
  cart: cartSlice,
  modal: modalReducer,
  futurePow: futurePowSlice,
  twoFuturePowBundle: twoFuturePowBundleSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
